document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection-description.js-collection-desc').forEach(function (wrapper) {
    var inner = wrapper.querySelector('.collection-description__inner');
    var btn = wrapper.querySelector('.collection-desc__toggle');
    if (!inner || !btn) return;

    function checkOverflow() {
      if (wrapper.classList.contains('is-expanded')) {
        btn.style.display = '';
        return;
      }

      if (inner.scrollHeight <= inner.clientHeight + 1) {
        btn.style.display = 'none';
      } else {
        btn.style.display = '';
      }
    }

    checkOverflow();
    window.addEventListener('resize', function () {
      setTimeout(checkOverflow, 100);
    });

    btn.addEventListener('click', function () {
      var expanded = wrapper.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? 'Weniger lesen' : 'Mehr lesen';

      if (!expanded) {
        setTimeout(checkOverflow, 0);
      }
    });
  });
});